import React, { Fragment, useState, useContext, useEffect, Component } from "react";

import { GlobalContext } from "./PA";

import ReactDOM from "react-dom";
import PAwebhooksPop from "./PAwebhooksPop";



import {
  Modal,
  FormFooter,
  ModalAlert,
  Button,
  FormGroup,
  Input,
  Select,
  Head,
  Checkbox,
  Textarea,
  ImagePicker
} from "xsolla-uikit";
import { IntlProvider } from "react-intl";


export default function (props) {

  let globalContext = useContext(GlobalContext);

  let [state, setState] = useState(
    {
      ...globalContext,
      current: 1
    }
  )

  return (
    <Fragment>
      <PAwebhooks {...globalContext} {...props}/>
    </Fragment>
  )
}




export class PAwebhooks extends Component {
  constructor(props) {
    super(props);
    this.handleWebhooks = props.handleWebhooks;
    this.state = {
      webhooks: {
        value: false,
        isFormModalOpen: false
      }
    };
  }

  handleModal = () => {
    this.setState({
      webhooks: {
        ...this.state.webhooks,
        isFormModalOpen: !this.state.webhooks.isFormModalOpen
      }
    });
  };

  render() {
    return (



      <div className="webhooks-block">

      {this.props.globalState
        && this.props.globalState.globalWebhooks.value
        && <FormGroup label='Use Webhooks' indentation="md">
         <div
                className="webhooks-block__form"
                style={{
                  display: "block",
                  width: '100%',
                  textOverflow: 'ellipsis',
                }}
              ><FormGroup label="Webhooks URL">
                {/* <div style={{
                  display: "block",
                  width: '100%',
                  textOverflow: 'ellipsis',
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                }}>
                https://secure.xsolla.com/api/calc/billing/sample.universal.php
              </div> */}
              <div style={{display: 'flex', width: '100%'}}>

              <Input
                style={{flexGrow: 1, marginRight: 16}}
                disabled={true}
                input={{
                  value:'https://secure.xsolla.com/api/calc/billing/sample.universal.php',
                  onChange: ()=>{void(0)}
                }}/>

               {/* <p>Webhooks are successfully set.</p> */}

                 <Button
                 icon="edit"
                 appearance="square"
                 size="sm"
                 onClick={() =>
                  this.setState({
                    webhooks: {
                      ...this.state.webhooks,
                      isFormModalOpen: true
                    }})
                  }
                 ></Button>
                </div>
               </FormGroup>
              </div>


          </FormGroup>}


      {this.props.globalState
        && !this.props.globalState.globalWebhooks.value
        &&

        <FormGroup indentation="md">


              <div
                className="gateway-card gateway-card--click-enabled"
                style={{ height: "100%", width: '100%' }}
              >
                <div style={{ padding: "16px 16px 0 16px", display: "flex" }}>
                  <div style={{ flexGrow: 1 }}>
                    <h4 style={{ lineHeight: "120%" }}>Use webhooks</h4>
                  </div>
                  {/* <div className={`card-app__image card-app__image--${icon}`} /> */}
                </div>
                <div
                  className="ui-form__input-description"
                  style={{
                    padding: "8px 16px 24px 16px",
                    display: "flex",
                    flexGrow: 1
                  }}
                >
                  <p className="xsui-typography--caption">Receive notifications for events to automate functions, such
                    as providing a payment status. You need to set up your
                    server to receive webhooks. <a
                      href="https://developers.xsolla.com/api/v2/getting-started/#api_webhooks"
                      className="webhooks-block__description__link"
                      target="_blank"
                    >
                      Webhooks documentation
                    </a></p>
                </div>

                <div className="gateway-card__delimiter" />
                <div className="gateway-card__content">
                  <div
                    className="gateways-list__item-panel"
                    onClick={() => {
                      // setState({
                        // connected: !state.connected,
                        // pop: !state.pop
                      // });
                    }}
                  >
                    <span className="gateways-list__item-panel-configure">
                      <div className="gateways-list__item-panel-configure-shape" />

                      <Button appearance="flatten"
                        onClick={() =>
                          this.setState({
                            webhooks: {
                              ...this.state.webhooks,
                              isFormModalOpen: true
                            }
                          })
                        }
                      >
                        Set up webhooks

                      </Button>
                    </span>
                  </div>
                </div>
              </div>




            </FormGroup>






          }


{this.state.webhooks["isFormModalOpen"] && (
  <PAwebhooksPop
    handleWebhooks = {this.props.handleWebhooks}
    handleModal={this.handleModal.bind(this)}
    isFormModalOpen={this.state.webhooks["isFormModalOpen"]}
  />
)}


        {/* <div className="webhooks-block__separator" />
        <div className="webhooks-block__test-forms-container">
          <div className="ui-navigation ui-navigation--size-lg ui-navigation--bordered">
            <div className="ui-navigation__menu">
              <div className="ui-navigation__section">
                <a className="ui-navigation__item ui-navigation__item--active" aria-current="true" href="/2340/projects/42656/edit/webhooks">Virtual Currency</a>
                <a className="ui-navigation__item" aria-current="false" href="/2340/projects/42656/edit/webhooks/virtual-items">Virtual Items</a>
                <a className="ui-navigation__item" aria-current="false" href="/2340/projects/42656/edit/webhooks/subscriptions">Subscriptions</a>
                <a className="ui-navigation__item" aria-current="false" href="/2340/projects/42656/edit/webhooks/pay2play">Game Keys</a>
                <a className="ui-navigation__item" aria-current="false" href="/2340/projects/42656/edit/webhooks/checkout">Checkout</a>
              </div>
              <div className="ui-navigation__section ui-navigation__section--actions" />
            </div>
          </div>
          <div className="ui-empty-view">
            <div className="ui-empty-view__title">Virtual Currency</div>
            <div className="ui-empty-view__content">
              <div>Sell packages of virtual currency that players use to make in-game purchases</div>
              <a href="https://developers.xsolla.com/doc/store/#guides_store_monetization_options_virtual_currency" className="webhooks-block__description__link" target="_blank" data-id="pa_webhooks_virtual-currency_learn-more">Learn more</a>
            </div>
            <button className="xsui-button xsui-button--appearance-outline xsui-button--size-md" type="button">Connect</button>
          </div>
        </div> */}



        </div>


    )
  }
}
